{
  "version": 1,
  "asset_id": "5e7b689c-6760-4857-aa17-e63e91875479",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/5e7b689c-6760-4857-aa17-e63e91875479/gallery-1.jpeg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/5e7b689c-6760-4857-aa17-e63e91875479/gallery-1.jpeg",
  "original_filename": "gallery-1.jpeg",
  "size": 1169202,
  "content_type": "image/jpeg",
  "created_at": "2026-07-01T04:21:36Z"
}
